import { ProductListingTable } from '../ProductListingTable';

interface ProcessedProduct {
  id: string;
  companyName: string;
  name: string;
  price: number;
  techScore: number;
  userRating: number;
  marketAppeal: number;
  releaseDate?: { day: number; month: number; year: number };
  discontinuedDate?: { day: number; month: number; year: number };
  status: string;
  unitsSold: number;
  marketShare: number;
  isPlayerProduct: boolean;
  inventory?: number;
}

interface ProductListingsContainerProps {
  products: ProcessedProduct[];
  loading?: boolean;
  onProductAction?: (productId: string, action: string) => void;
}

export function ProductListingsContainer({ 
  products,
  loading = false,
  onProductAction
}: ProductListingsContainerProps) {
  if (loading) {
    return <div className="flex justify-center items-center p-8">Loading products...</div>;
  }

  return (
    <ProductListingTable 
      products={products}
      onProductAction={onProductAction}
    />
  );
}